import React from 'react';
import {
  arrayOf, bool, func, number, oneOfType, shape, string
} from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from '@thd-olt-component-react/grid';

export const CalculatorAreaElement = (props) => {
  const MIN_AREA_NUMBER = 1;
  const {
    errorBox,
    valueAreas,
    valueDepths,
    index,
    step,
    channel,
    calculatorType,
    lineItemName,
    handleChange,
    removeAreaElement
  } = props;

  const suffixWidthClassName = classNames({
    'calculator__suffix-width': channel !== 'mobile',
    'calculator__suffix-width-mobile': channel === 'mobile'
  });
  const suffixDepthClassName = classNames({
    'calculator__suffix-depth': channel !== 'mobile',
    'calculator__suffix-depth-mobile': channel === 'mobile'
  });
  const inputClassArea = classNames('calculator__input-wrapper-width', 'form-input', {
    'form-input--error': errorBox
  });
  const inputClassHeader = classNames({
    'calculator__input-header': channel === 'desktop'
  });
  const inputClassDepth = classNames('calculator__input-wrapper-depth', 'form-input', 'calculator__depth-area');
  return (
    <div>
      <div className="u__bold calculator__add-area-text">
        {`${lineItemName} ${index + 1}`}
      </div>
      <div className="calculator__inputs">
        <Col nopadding>
          <div className={inputClassArea}>
            <div className={inputClassHeader}>
              Square Footage
            </div>
            <input
              data-testid="calculator-input"
              className="form-input__field calculator__input-disable-zoom"
              min={0}
              onChange={(event) => handleChange(event, index)}
              type="number"
              value={valueAreas[index].value}
            />
            {!errorBox
                && (
                  <span className={suffixWidthClassName}>
                    sq. ft
                  </span>
                )}
          </div>
        </Col>
        {calculatorType === 'Volume' && (
          <Col nopadding>
            <div className={inputClassDepth}>
              <div className={inputClassHeader}>
                Depth:
              </div>
              <input
                className="form-input__field calculator__input-disable-zoom calculator__input-wrapper-depth--field"
                min={0}
                name="depth"
                onChange={(event) => handleChange(event, index)}
                type="number"
                value={valueDepths[index]}
              />
              <span className={suffixDepthClassName}>
                in
              </span>
              <div className="calculator__input-wrapper-depth-subtext">
                (3 in. recommended)
              </div>
            </div>
          </Col>
        )}
        <Col>
          {step > MIN_AREA_NUMBER
            && (
              <button
                type="button"
                aria-label="Save"
                className="calculator__close-icon"
                onClick={() => removeAreaElement(index)}
              />
            )}
        </Col>
      </div>
    </div>
  );
};

CalculatorAreaElement.propTypes = {
  index: number.isRequired,
  errorBox: bool.isRequired,
  lineItemName: string,
  valueAreas: arrayOf(shape({
    value: string,
    changed: bool,
  }).isRequired).isRequired,
  valueDepths: arrayOf(string),
  calculatorType: string,
  step: number.isRequired,
  channel: string.isRequired,
  handleChange: func.isRequired,
  removeAreaElement: func.isRequired
};
CalculatorAreaElement.defaultProps = {
  lineItemName: '',
  calculatorType: 'Area',
  valueDepths: ['3']
};
